import { render, staticRenderFns } from "./TinyMce.vue?vue&type=template&id=64111525&scoped=true&lang=pug&"
import script from "./TinyMce.vue?vue&type=script&lang=ts&"
export * from "./TinyMce.vue?vue&type=script&lang=ts&"
import style0 from "./TinyMce.vue?vue&type=style&index=0&id=64111525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64111525",
  null
  
)

export default component.exports